import { Component, OnInit } from '@angular/core';
import {
  getRedemptionCodeSetProductTypeDisplay,
  RedemptionCode,
  RedemptionCodeSet,
  RedemptionCodeSetStatus,
  RedemptionCodeStatus,
} from '../../../../../../models/redemption-code';
import { ActivatedRoute } from '@angular/router';
import { RedemptionCodeService } from '../../../../../../services/redemption-code/redemption-code.service';
import {
  CallbackResult,
  CallbackResultStatus,
  dateStringFromISO8601,
  getStaffNameDisplay,
  timeStringFromISO8601,
} from '../../../../../../utils';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';
import { AccountService } from '../../../../../../services/account/account.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RenameRedemptionCodeSetModalComponent,
} from './modals/rename-redemption-code-set-modal/rename-redemption-code-set-modal.component';
import {
  EditRedemptionCodeSetExpirationModalComponent,
} from './modals/edit-redemption-code-set-expiration-modal/edit-redemption-code-set-expiration-modal.component';
import {
  ExportRedemptionCodesModalComponent,
} from './modals/export-redemption-codes-modal/export-redemption-codes-modal.component';


@Component({
  selector: 'app-redemption-code-set',
  templateUrl: './redemption-code-set.component.html',
  styleUrls: ['./redemption-code-set.component.css']
})
export class RedemptionCodeSetComponent implements OnInit {
  public redemptionCodeSetIdInt: number;
  public redemptionCodeSet: RedemptionCodeSet;
  public redemptionCodes: RedemptionCode[] = null;

  public redemptionCodeStatus: RedemptionCodeStatus = null;

  public loadingRedemptionCodeSet = true;
  public loadingRedemptionCodes = true;

  public setNotFound = false;
  public serverError: number = null;

  public callbackResult: CallbackResult = null;

  public readonly RedemptionCodeSetStatus = RedemptionCodeSetStatus;
  public readonly RedemptionCodeStatus = RedemptionCodeStatus;
  public readonly CallbackResultStatus = CallbackResultStatus;
  public readonly getRedemptionCodeSetProductTypeDisplay = getRedemptionCodeSetProductTypeDisplay;
  public readonly dateStringFromISO8601 = dateStringFromISO8601;
  public readonly getStaffNameDisplay = getStaffNameDisplay;
  public readonly timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public orgConfig: OrganizationConfigService,
    public accountService: AccountService,
    private route: ActivatedRoute,
    private redemptionCodeService: RedemptionCodeService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    this.redemptionCodeSetIdInt = parseInt(routeParams.id, 10);
    if (isNaN(this.redemptionCodeSetIdInt)) {
      this.setNotFound = true;
      return;
    }

    this.loadRedemptionCodeSet();
    this.loadRedemptionCodes();
  }

  public openRenameModal() {
    this.callbackResult = null;

    const modalRef = this.modalService.open(
      RenameRedemptionCodeSetModalComponent
    );
    modalRef.componentInstance.redemptionCodeSet = this.redemptionCodeSet;
    modalRef.componentInstance.savedCallback = () => {
      this.loadRedemptionCodeSet();
    };
  }

  public openEditExpirationModal() {
    this.callbackResult = null;

    const modalRef = this.modalService.open(
      EditRedemptionCodeSetExpirationModalComponent
    );
    modalRef.componentInstance.redemptionCodeSet = this.redemptionCodeSet;
    modalRef.componentInstance.savedCallback = () => {
      this.loadRedemptionCodeSet();
    };
  }

  public openExportCodesModal() {
    this.callbackResult = null;

    const modalRef = this.modalService.open(
      ExportRedemptionCodesModalComponent
    );
    modalRef.componentInstance.redemptionCodeSet = this.redemptionCodeSet;
    modalRef.componentInstance.redemptionCodes = this.redemptionCodes;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.callbackResult = result;
    };
  }

  public getFilteredRedemptionCodes(): RedemptionCode[] {
    if (this.redemptionCodes === null) { return []; }

    if (this.redemptionCodeStatus === null) { return this.redemptionCodes; }

    return this.redemptionCodes.filter(rc => rc.status === this.redemptionCodeStatus);
  }

  public getNumberOfRedeemedCodes(): number | null {
    if (this.loadingRedemptionCodes) { return null; }
    if (this.redemptionCodes === null) { return null; }

    return this.redemptionCodes.filter(rc => rc.status === RedemptionCodeStatus.redeemed).length;
  }

  private loadRedemptionCodeSet() {
    this.loadingRedemptionCodeSet = true;

    this.redemptionCodeService
      .getRedemptionCodeSet(this.redemptionCodeSetIdInt)
      .then(redemptionCodeSet => {
        this.redemptionCodeSet = redemptionCodeSet;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.setNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRedemptionCodeSet = false; });
  }

  private loadRedemptionCodes() {
    this.loadingRedemptionCodes = true;

    this.redemptionCodeService
      .getRedemptionCodes(
        this.redemptionCodeSetIdInt,
        1,
        3000
      )
      .then(result => {
        this.redemptionCodes = result.results;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.setNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRedemptionCodes = false; });
  }
}
